import { Module, ModuleRegistry } from 'ag-grid-community';
import { LicenseManager } from 'ag-grid-enterprise';

export function activateAgGridEnterprise(
  licenseKey: string,
  enterpriseModules: Module[]
) {
  LicenseManager.setLicenseKey(licenseKey);
  ModuleRegistry.registerModules(enterpriseModules);
}
